import React from 'react';
import MemberPicker from './MemberPicker';
import { input as inputStyle, select as selectStyle } from './trackUi';

export const FIELD_TYPE_OPTIONS = [
  { value: 'text', label: '簡答' },
  { value: 'textarea', label: '段落' },
  { value: 'number', label: '數字' },
  { value: 'date', label: '日期' },
  { value: 'time', label: '時間' },
  { value: 'datetime', label: '日期時間' },
  { value: 'select', label: '下拉選單' },
  { value: 'multiselect', label: '核取方塊（多選）' },
  { value: 'checkbox', label: '是／否' },
  { value: 'member', label: '成員' },
  { value: 'url', label: '連結' },
];

function toLocalDatetime(v) {
  if (!v) return '';
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return '';
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
}

export function formatFieldValue(field, v, members) {
  if (v == null || v === '' || (Array.isArray(v) && !v.length)) return '';
  switch (field.fieldType) {
    case 'checkbox': return v ? '是' : '否';
    case 'member': return (members || []).find((m) => m.id === Number(v))?.name || '';
    case 'datetime': return toLocalDatetime(v).replace('T', ' ');
    default: return Array.isArray(v) ? v.join('、') : String(v);
  }
}

export default function DynamicField({ field, value, onChange, members, style }) {
  const opts = Array.isArray(field.options) ? field.options : [];
  const ph = field.placeholder || '';
  const full = { ...inputStyle, width: '100%', ...style };
  switch (field.fieldType) {
    case 'textarea':
      return <textarea rows={3} style={full} placeholder={ph} value={value ?? ''} onChange={(e) => onChange(e.target.value)} />;
    case 'number':
      return (
        <input
          type="number"
          style={full}
          placeholder={ph}
          value={value ?? ''}
          onChange={(e) => onChange(e.target.value === '' ? null : Number(e.target.value))}
        />
      );
    case 'date':
      return <input type="date" style={full} value={value || ''} onChange={(e) => onChange(e.target.value || null)} />;
    case 'time':
      return <input type="time" style={full} value={String(value || '').slice(0, 5)} onChange={(e) => onChange(e.target.value || null)} />;
    case 'datetime':
      return (
        <input
          type="datetime-local"
          style={full}
          value={toLocalDatetime(value)}
          onChange={(e) => onChange(e.target.value ? new Date(e.target.value).toISOString() : null)}
        />
      );
    case 'select':
      return (
        <select style={{ ...selectStyle, width: '100%', ...style }} value={value ?? ''} onChange={(e) => onChange(e.target.value || null)}>
          <option value="">{ph || '請選擇'}</option>
          {opts.map((o) => <option key={o} value={o}>{o}</option>)}
        </select>
      );
    case 'multiselect': {
      const arr = Array.isArray(value) ? value : [];
      return (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px 12px' }}>
          {opts.map((o) => (
            <label key={o} style={{ fontSize: 13, display: 'inline-flex', gap: 4, alignItems: 'center' }}>
              <input
                type="checkbox"
                checked={arr.includes(o)}
                onChange={(e) => onChange(e.target.checked ? [...arr, o] : arr.filter((x) => x !== o))}
              />
              {o}
            </label>
          ))}
          {!opts.length && <span style={{ fontSize: 12, color: '#9ca3af' }}>尚未設定選項</span>}
        </div>
      );
    }
    case 'checkbox':
      return (
        <label style={{ fontSize: 13, display: 'inline-flex', gap: 6, alignItems: 'center' }}>
          <input type="checkbox" checked={!!value} onChange={(e) => onChange(e.target.checked)} />
          {ph || '是'}
        </label>
      );
    case 'member':
      return <MemberPicker members={members} value={value} onChange={onChange} style={{ width: '100%', ...style }} />;
    case 'url':
      return <input type="url" style={full} placeholder={ph || 'https://'} value={value ?? ''} onChange={(e) => onChange(e.target.value)} />;
    default:
      return <input style={full} placeholder={ph} value={value ?? ''} onChange={(e) => onChange(e.target.value)} />;
  }
}
